export default __webpack_public_path__ + "img/x.725c80d4.svg";